"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadNativeAd = exports.useNativeAd = void 0;
var react_1 = require("react");
var lazy_1 = require("../utils/lazy");
function warnIfRemoved(target) {
    if ('MutationObserver' in window) {
        var observer_1 = new MutationObserver(function (mutations) {
            var targetRemoved = mutations.some(function (mutation) {
                return Array.from(mutation.removedNodes).indexOf(target) !== -1;
            });
            if (targetRemoved) {
                console.warn("Native ad container " + target.id + " removed from DOM. Impressions and clicks will not be registred");
            }
        });
        if (target.parentNode) {
            observer_1.observe(target.parentNode, {
                childList: true,
            });
        }
        var cleanup = function () {
            observer_1.disconnect();
        };
        return cleanup;
    }
    return function () {
        console.info('MutationObserver not available');
    };
}
var bannerDeviceType = function (deviceType) {
    switch (deviceType) {
        case 'desktop':
            return 'wde';
        case 'tablet':
            return 'wtb';
        case 'mobile':
            return 'wph';
    }
};
var loadElement = function (ele) {
    var tagId = ele.getAttribute('id');
    if (tagId) {
        if (window.apntag) {
            window.apntag.anq.push(function () {
                if (window.apntag) {
                    window.apntag.showTag(tagId);
                }
            });
        }
    }
};
function recircIndex(id) {
    var lastNumber = /(\d+)(?!.*\d)/;
    var numberAsMatch = id.match(lastNumber);
    if (numberAsMatch) {
        var numberAsString = numberAsMatch[0];
        var parsedNumber = parseInt(numberAsString, 10);
        return parsedNumber > 3 ? 4 : parsedNumber;
    }
    return 0;
}
function useNativeAd(instanceId, pageType, deviceType, keywords) {
    var _a = react_1.useState(false), loaded = _a[0], setLoaded = _a[1];
    var _b = react_1.useState(), data = _b[0], setData = _b[1];
    var _c = react_1.useState(), error = _c[0], setError = _c[1];
    react_1.useEffect(function () {
        if (pageType && deviceType && window.apntag && window.apntag.anq) {
            var index_1 = recircIndex(instanceId);
            var devicePrefix_1 = bannerDeviceType(deviceType);
            var formatPrefix_1 = deviceType === 'mobile' ? 'board' : 'netboard';
            var categoryKeywords_1 = Object.entries(keywords).reduce(function (previousValue, _a) {
                var key = _a[0], value = _a[1];
                previousValue["no-sno-finn-" + key] = value;
                return previousValue;
            }, {});
            window.apntag.anq.push(function () {
                var streamTag = {
                    invCode: "no-finn-" + devicePrefix_1 + "-" + pageType + "_recirc_" + index_1,
                    sizes: [[1, 1]],
                    allowedFormats: ['native'],
                    targetId: instanceId,
                    keywords: __assign({ 'no-sno-finn-section': 'bap', 'no-sno-finn-subsection': 'bap_forsale', 'no-sno-adformat': [formatPrefix_1 + "_recirc"] }, categoryKeywords_1),
                };
                if (window.apntag) {
                    window.apntag.defineTag(streamTag);
                    window.apntag.loadTags();
                    window.apntag.onEvent('adAvailable', instanceId, function (adObj) {
                        if (adObj &&
                            adObj.adType === 'native' &&
                            adObj.source === 'rtb') {
                            setData(adObj);
                            if (window.apntag) {
                                window.apntag.attachClickTrackers(adObj, adObj.targetId);
                            }
                            var element = document.getElementById(adObj.targetId);
                            if (element) {
                                var cleanup_1 = warnIfRemoved(element);
                                lazy_1.inscreen(element, function (ele) {
                                    cleanup_1();
                                    loadElement(ele);
                                });
                            }
                        }
                        setLoaded(true);
                    });
                    window.apntag.onEvent('adLoaded', instanceId, function (adObj) {
                        if (adObj &&
                            adObj.adType === 'native' &&
                            adObj.source === 'rtb') {
                            if (window.apntag) {
                                window.apntag.fireImpressionTrackers(adObj);
                            }
                        }
                    });
                    window.apntag.onEvent('adNoBid', instanceId, function () {
                        setLoaded(true);
                    });
                    window.apntag.onEvent('adBadRequest', instanceId, function (error) {
                        setLoaded(true);
                        setError(error);
                    });
                }
            });
        }
        else {
            setLoaded(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // We only want this to run once
    return { data: data, loaded: loaded, error: error };
}
exports.useNativeAd = useNativeAd;
function useLoadNativeAd(adObj, status) {
    if (status === void 0) { status = 'available'; }
    react_1.useEffect(function () {
        if (adObj && window.apntag && window.apntag.anq) {
            window.apntag.anq.push(function () {
                if (window.apntag) {
                    window.apntag.attachClickTrackers(adObj, adObj.targetId);
                    if (status === 'loaded') {
                        window.apntag.fireImpressionTrackers(adObj);
                    }
                    else {
                        window.apntag.onEvent('adLoaded', adObj.targetId, function (adObj) {
                            if (adObj &&
                                adObj.adType === 'native' &&
                                adObj.source === 'rtb') {
                                if (window.apntag) {
                                    window.apntag.fireImpressionTrackers(adObj);
                                }
                            }
                        });
                    }
                }
                var element = document.getElementById(adObj.targetId);
                if (element) {
                    var cleanup_2 = warnIfRemoved(element);
                    lazy_1.inscreen(element, function (ele) {
                        cleanup_2();
                        loadElement(ele);
                    });
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // We only want this to run once
    return {};
}
exports.useLoadNativeAd = useLoadNativeAd;
